import { render } from "./PreFilterGalleries.vue?vue&type=template&id=6949feb6&scoped=true"
import script from "./PreFilterGalleries.vue?vue&type=script&lang=js"
export * from "./PreFilterGalleries.vue?vue&type=script&lang=js"

import "./PreFilterGalleries.vue?vue&type=style&index=0&id=6949feb6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6949feb6"

export default script